'use strict';

/*
 <h-form-layout view="in_modal_layout">
 <h-form view="basic_info" order="[]" ></h-form>
 </h-form-layout>

 <h-form-layout view="in_page_layout">

 <h-http-form-flow link="modules/forms/scripts/normal_flow.json.js">1</h-http-form-flow>

 <h-form-flow>
 <h-form view="basic_info" order="[]" ></h-form>
 <h-form view="employer_type" order="[]" ></h-form>
 </h-form-flow>

 <h-dyn-form-flow forms="['basic_info', 'employer_type', {form:'user_type', order:[1,2,3]}]" />

 </h-form-layout>
 */

angular.module('harriApp')

    .directive('hFormLayout', ['$log', function () {
        return {
            restrict: "E",
            replace: 'true',
            transclude: true,
            scope: {},
            templateUrl: function (element, attrs) {

                var FORMS_LAYOUTS_MAP = {
                    'basic_layout': '../modules/forms/layouts/basic_layout.html',
                    'default_modal_layout': '../modules/forms/layouts/default_modal_layout.html',
                    'empty_div': '../modules/forms/layouts/empty_div.html',
                    'in_modal_layout': '../modules/forms/layouts/in_modal_layout.html',
                    'in_page_layout': '../modules/forms/layouts/in_page_layout.html',
                    'login_layout': '../modules/forms/layouts/login_layout.html',
                    'login_modal_layout': '../modules/forms/layouts/login_modal_layout.html',
                    'white_layout': '../modules/forms/layouts/white_layout.html',
                };

                var view = 'in_page_layout';

                if (attrs.view) {
                    view = attrs.view;
                }

                view = view.toLowerCase().replace(/\.(html)/g, "");
                view = FORMS_LAYOUTS_MAP[view] || console.error("hForm view html URL must be added in FORMS_LAYOUTS_MAP, can't find:", view);

                return view || false;
            },
            link: function (scope, element, attrs) {
                scope.layout = attrs.view;
            }
        }
    }])

    .directive('hFormAnimate', ["$timeout", function ($timeout) {
        return {
            restrict: "A",
            link: function (scope, element, attrs) {
                scope.$on("animate-" + attrs.hFormAnimate, function (event, animation) {

                    element.removeClass().addClass('animated').addClass(animation).one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function () {
                        $(this).removeClass();
                    });

                });
            }
        }
    }])

    .directive('hFormFlow', ['$log', function ($log) {
        return {
            restrict: "E",
            replace: 'true',
            transclude: true,
            template: '<div class="form-flow" ng-transclude></div>',
            compile: function (element, attributes) {

                return {
                    pre: function (scope, element, attrs, controller, transcludeFn) {
                        scope.isWizard = attrs.wizard == "true" || attrs.wizard == true || attrs.wizard == undefined;
                    },
                    post: function (scope, element, attrs) {
                        scope.name = attrs.name;

                        if (scope.name) {
                            scope.$on(scope.name + ":sendData", function (event, data, index) {
                                scope.load(data, index);
                            });
                            scope.$on(scope.name + ":getScope", function (event, cp) {
                                if (cp) {
                                    cp(scope);
                                }
                            });
                        }
                    }
                }
            },
            controller: 'hFormController'
        }
    }])

    .directive('hDynFormFlow', ['$log', '$compile', 'hFormReference', function ($log, $compile, hFormReference) {
        return {
            restrict: "E",
            replace: 'true',
            transclude: true,
            scope: {
                views: '<',
            },
            compile: function (celement, cattrs, transclude) {
                return function (scope, element, attrs) {

                    var template = '<h-form-flow>';
                    if (attrs.wizard) {
                        template = '<h-form-flow wizard="' + attrs.wizard + '">';
                    }

                    for (let i = 0; i < scope.views.length; i++) {
                        var form = scope.views[i];
                        var formOrder = [];
                        var directive = '';
                        var options = '{}';
                        var optional = false;
                        let nextView;

                        if (scope.views[i].form) {
                            form = scope.views[i].form;
                            formOrder = scope.views[i].order;
                            directive = scope.views[i].directive;
                            options = scope.views[i].options;
                            optional = scope.views[i].optional;
                            nextView = i === scope.views.length ? scope.views[0].view : (scope.views[i + 1] && scope.views[i + 1].view);
                        }

                        template += '<h-form optional="' + optional + '"  options="' + options + '" ' + directive + ' view="' + form + '" order="[' + formOrder + ']" next-view="' + nextView + '"';

                        if (scope.views[i].getForm) {
                            hFormReference.formsObjMap[form] = scope.views[i].getForm();
                            template += 'new="true"  title="' + scope.views[i].title + '"';
                        }

                        template += '></h-form>';

                    }

                    template += '</h-form-flow>';


                    var $template = angular.element(template);
                    $compile($template)(scope);
                    element.html($template);
                }
            }

        }
    }])

    .directive('hFormLoading', function () {
        return {
            restrict: "E",
            replace: 'true',
            template: '<div class="spinner"><div class="dot1"></div><div class="dot2"></div></div>',
        }
    })

    .directive('hClearField', [function () {
        return {
            restrict: 'C',
            link: function (scope, el, attrs, ngModel) {
                el.bind("click", function () {
                    $(this).parent().find("input").val("");
                });
            }
        }
    }])

    .directive('generateValidateSlug', ["$filter", "httpHelper", function ($filter, httpHelper) {


        return {
            require: 'ngModel',
            link: function (scope, $elm, attrs, ngModel) {

                var $firstLastName = $('#slugvalidate-firstname, #slugvalidate-lastname');
                var $usernameContainer = $('#username-container');
                var $usernameErrorContainer = $usernameContainer.find('.help-block');

                $firstLastName.change(function () {
                    var name = [];
                    $firstLastName.each(function () {
                        var $this = $(this);
                        if ($.trim($this.val()) != '') {
                            name.push($(this).val());
                        }
                    });

                    var concatedName = $filter('username')(name.join(' '));
                    $elm.val(concatedName);
                    validateSlug(concatedName, true);
                });


                function validateSlug(username, showSuggested) {

                    $usernameContainer.removeClass('has-error');
                    $usernameErrorContainer.hide();

                    ngModel.$setValidity('$required', true);
                    ngModel.$setValidity('$slugError', true);

                    var regex = /^[a-zA-Z0-9_-]+$/;

                    if (username == '') {
                        $usernameContainer.addClass('has-error');
                        $usernameErrorContainer.html($filter('translate')('Please enter your personal Harri URL.'));
                        $usernameErrorContainer.show();
                        ngModel.$setValidity('$required', false);
                        return;
                    } else if (!regex.test(username)) {
                        $usernameContainer.addClass('has-error');
                        $usernameErrorContainer.html($filter('translate')('Only letters, numbers, underscores(_) and dashes(-) is allowed'));
                        $usernameErrorContainer.show();
                        ngModel.$setValidity('$required', false);
                        return;
                    }


                    ngModel.$setValidity('$slugError', false);
                    $elm.addClass('ng-processing');
                    httpHelper.p('registration/validateUsername', {
                        'username': username
                    }).then(function (data) {
                        $elm.removeClass('ng-processing');
                        if (data && data.data && data.data.data && data.data.data.error) {
                            ngModel.$setValidity('$slugError', false);
                            if (showSuggested && data.data.data.suggested) {
                                $elm.val(data.data.data.suggested);
                                validateSlug(data.data.data.suggested, false);
                            }
                            else {
                                $usernameContainer.addClass('has-error');
                                $usernameErrorContainer.html($filter("translate")(data.data.data.error));
                                $usernameErrorContainer.show();
                            }
                        }
                        else {
                            ngModel.$setValidity('$slugError', true);
                        }
                    })
                    .catch(function (err) {
                        hLog("formsDirectives", "validateUsername", err);
                    });
                }

                $elm.unbind('change');
                $elm.change(function () {
                    validateSlug($(this).val(), false);
                });

            }
        }
    }])

    //EDITED | source from: https://github.com/webadvanced/ng-remote-validate
    .directive('hRemoteValidate', [ '$http', '$timeout', '$q', '$filter', 'asyncGlobalHandler', function ($http, $timeout, $q, $filter, asyncGlobalHandler) {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, el, attrs, ngModel) {
                var cache = {},
                    handleChange,
                    setValidation,
                    addToCache,
                    request,
                    shouldProcess,
                    directiveId = 'hRemoteValidate',
                    options = {
                        ngRemoteThrottle: 400,
                        ngRemoteMethod: 'POST'
                    },
                    skipString = '';


                angular.extend(options, attrs);

                if (options[directiveId].charAt(0) === '[') {
                    options.urls = eval(options[directiveId]);
                } else {
                    options.urls = [ options[directiveId] ];
                }

                addToCache = function (response) {
                    var value = response[0].config.data[attrs.name];
                    if (cache[ value ]) return cache[ value ];
                    cache[ value ] = response;
                };

                shouldProcess = function (value) {

                    //ignore the first value in the attrs.ignoreSlug
                    if(attrs.ignoreSlug) {

                        if(!skipString) {
                            var ignoreSlugValue = scope.$eval(attrs.ignoreSlug);

                            if(ignoreSlugValue) {
                                skipString = ignoreSlugValue;
                            }
                        }

                        if(skipString == value) {
                            return false;
                        }
                    }

                    var otherRulesInValid = false;
                    for (var p in ngModel.$error) {
                        if (ngModel.$error[ p ] && p != directiveId) {
                            otherRulesInValid = true;
                            break;
                        }
                    }
                    return !(  otherRulesInValid );
                };

                setValidation = function (response, skipCache) {
                    ngModel[directiveId] = {};

                    var i = 0,
                        l = response.length,
                        isValid = true;

                    var errorMessages = [];
                    var errorMessagesCodes;
                    for (; i < l; i++) {
                        //look for suggestion
                        if (response[ i ].data.data.suggested && !ngModel.suggested) {
                            var suggested = response[ i ].data.data.suggested;
                            $timeout(function () {
                                ngModel.$setViewValue(suggested);
                                ngModel.$setPristine();
                                ngModel.$render();
                            });
                            ngModel[directiveId].suggested = suggested;
                            ngModel.suggested = true;
                            isValid = true;
                            break;
                        }

                        if (attrs.name === 'email') {
                            switch (response[ i ].data.data.status.status) {
                                case "USED":
                                    if (response[ i ].data.data.status.user.status === "NO_PASSWORD") {
                                        errorMessagesCodes = "NO_PASSWORD";
                                    } else if (response[ i ].data.data.status.user.status === "DRAFT_NO_PASSWORD") {
                                        errorMessagesCodes = "DRAFT_NO_PASSWORD";
                                    } else {
                                        errorMessages.push($filter("translate")("Email already used"));
                                    }
                                    isValid = false;
                                    break;
                            }
                        } else if (attrs.name === 'slug') {
                            if (response[ i ].data.data && response[ i ].data.data[0] && response[ i ].data.data[0].error){
                                errorMessages.push($filter("translate")(response[ i ].data.data[0].error));
                                isValid = false;
                            }
                            else if (response[ i ].data && response[ i ].data.data  && response[ i ].data.data.error){
                                errorMessages.push($filter("translate")(response[ i ].data.data.error));
                                isValid = false;
                            }
                        }

                        if( !isValid ){
                            break;
                        }

                    }

                    if (!skipCache) {
                        addToCache(response);
                    }
                    ngModel.$setValidity(directiveId, isValid);
                    el.removeClass('ng-processing');
                    ngModel.$_processing = false;

                    ngModel[directiveId].message = errorMessages.join(" ");
                    ngModel[directiveId].messageCode = errorMessagesCodes;
                };

                handleChange = function (value) {
                    if (ngModel[directiveId] && ngModel[directiveId].suggested && ngModel[directiveId].suggested == value) {
                        return;
                    }
                    if (typeof value === 'undefined') {
                        return;
                    }

                    if (!shouldProcess(value)) {
                        return setValidation([
                            { data: {
                                "data": {
                                    "status": {
                                        "status": ""
                                    }
                                },
                                "message": "Success",
                                "status": "",
                                "status_code": 200
                            } }
                        ], true);
                    }

                    if (cache[ value ]) {
                        return setValidation(cache[ value ], true);
                    }

                    if (request) {
                        $timeout.cancel(request);
                    }

                    request = $timeout(function () {
                        el.addClass('ng-processing');
                        ngModel.$_processing = true;
                        var calls = [],
                            i = 0,
                            l = options.urls.length,
                            toValidate = {},
                            httpOpts = { method: options.ngRemoteMethod };

                        toValidate[attrs.name] = value;

                        if (options.ngRemoteMethod == 'POST') {
                            httpOpts.data = toValidate;
                        } else {
                            httpOpts.params = toValidate;
                        }

                        for (; i < l; i++) {

                            httpOpts.url = options.urls[ i ];

                            if (httpOpts.url.indexOf("http") == -1) {
                                httpOpts.url = publicConfiguration.APIServerBaseURL + httpOpts.url;
                            }
                            httpOpts.withCredentials = true;
                            calls.push($http(httpOpts));
                        }

//                        asyncGlobalHandler.watchPromiseDict(calls, true);
                        $q.all(calls)
                            .then(setValidation)
                            .catch(function (err) {
                                hLog("formsDirectives", "setValidation", err);
                            });

                    }, options.ngRemoteThrottle);
                    return true;
                };

                scope.$watch(function () {
                    return ngModel.$viewValue;
                }, handleChange);
            }
        };
    }])


    .directive('passwordEmailMatch', [function () {
        return{
            restrict: 'E',
            require: 'ngModel',
            scope: {
                email: '=',
                formName: '='
            },
            link: function (scope, elm, attrs, ctrl) {

                scope.$watch('email', function (newValue, oldValue) {

                    if(newValue !== oldValue){
                        scope.formName.passwordEmailMatch.$validate();
                    }
                });

                ctrl.$validators.passwordEmailMatch = function (modelValue, viewValue) {

                    if(ctrl.$isEmpty(modelValue)){
                        return true;
                    }

                    return viewValue !== scope.email;
                };
            }
        }
    }])

    .directive('hForm', ['$log', 'hFormReference', '$q', function ($log, hFormReference, $q) {
        return {
            restrict: "EA",
            require: '^hFormFlow',
            templateUrl: function (element, attrs) {
                var view = '';
                var FORMS_VIEWS_MAP = {
                    'application/basic_info': '../modules/forms/views/application/basic_info.html',
                    'application/photo_apply': '../modules/forms/views/application/photo_apply.html',
                    'claim_brand/basic_info': '../modules/forms/views/claim_brand/basic_info.html',
                    'client_portal/share_via_email': '../modules/forms/views/client_portal/share_via_email.html',
                    'emp_quick_reg/brand': '../modules/forms/views/emp_quick_reg/brand.html',
                    'registration/_schedule': '../modules/forms/views/registration/_schedule.html',
                    'registration/about': '../modules/forms/views/registration/about.html',
                    'registration/brand': '../modules/forms/views/registration/brand.html',
                    'registration/brand_media': '../modules/forms/views/registration/brand_media.html',
                    'registration/company_profile': '../modules/forms/views/registration/company_profile.html',
                    'registration/education': '../modules/forms/views/registration/education.html',
                    'registration/education_details': '../modules/forms/views/registration/education_details.html',
                    'registration/hosted_video': '../modules/forms/views/registration/hosted_video.html',
                    'registration/location': '../modules/forms/views/registration/location.html',
                    'registration/schedule': '../modules/forms/views/registration/schedule.html',
                    'registration/skills': '../modules/forms/views/registration/skills.html',
                    'registration/thanks': '../modules/forms/views/registration/thanks.html',
                    'registration/user_media': '../modules/forms/views/registration/user_media.html',
                    'registration/work_history': '../modules/forms/views/registration/work_history.html',
                    'registration/work_history_details': '../modules/forms/views/registration/work_history_details.html',
                    'reset_password/enter_email': '../modules/forms/views/reset_password/enter_email.html',
                    'reset_password/invalid_token': '../modules/forms/views/reset_password/invalid_token.html',
                    'reset_password/new_password': '../modules/forms/views/reset_password/new_password.html',
                    'reset_password/reset_email_sent': '../modules/forms/views/reset_password/reset_email_sent.html',
                    'reset_password/updated_successfully': '../modules/forms/views/reset_password/updated_successfully.html',
                    'settings/harri_engage': '../modules/forms/views/settings/engagement_settings.html',
                    'settings/atrs_management': '../modules/forms/views/settings/atrs_management.html',
                    'settings/basic_information': '../modules/forms/views/settings/basic_information.html',
                    'settings/billing': '../modules/forms/views/settings/billing.html',
                    'settings/brand_notifications': '../modules/forms/views/settings/brand_notifications.html',
                    'settings/communication_emails': '../modules/forms/views/settings/communication_emails.html',
                    'settings/notification_receipt': '../modules/forms/views/settings/notification_receipt_settings.html',
                    'settings/eeo_forms': '../modules/forms/views/settings/eeo_forms.html',
                    'settings/email_notifications': '../modules/forms/views/settings/email_notifications.html',
                    'settings/general_settings': '../modules/forms/views/settings/general_settings.html',
                    'settings/job_templates': '../modules/forms/views/settings/job_templates.html',
                    'settings/offer_templates': '../modules/forms/views/settings/offer_templates.html',
                    'settings/social_referral_templates': '../modules/forms/views/settings/social_referral_templates.html',
                    'settings/hr_actions_templates': '../modules/forms/views/settings/hr_actions_templates.html',
                    'settings/crm': '../modules/forms/views/settings/crm_container.html',
                    'settings/locations': '../modules/forms/views/settings/locations.html',
                    'settings/manage_ams': '../modules/forms/views/settings/manage_ams.html',
                    'settings/blocked_terminated_employees': '../modules/forms/views/settings/blocked_terminated_employees.html',
                    'settings/media': '../modules/forms/views/settings/media.html',
                    'settings/new_brand_payment_method': '../modules/forms/views/settings/new_brand_payment_method.html',
                    'settings/background_checks': '../modules/forms/views/settings/background_checks.html',
                    'settings/emails_branding_settings': '../modules/forms/views/settings/emails_branding_settings.html',
                    'settings/pos_positions_mapping': '../modules/forms/views/settings/pos_positions_mapping.html',
                    'settings/positions_settings': '../modules/forms/views/settings/positions_settings.html',
                    'settings/communication-hub-settings': '../modules/forms/views/settings/communication_hub_settings.html',
                    'settings/reports-settings': '../modules/forms/views/settings/reports_settings.html',
                    'settings/rejection_templates': '../modules/forms/views/settings/rejection_templates.html',
                    'settings/reviews': '../modules/forms/views/settings/reviews.html',
                    'settings/automated_metrics': '../modules/forms/views/settings/automated_metrics.html',
                    'settings/manage_permissions': '../modules/forms/views/settings/manage_permissions.html',
                    'settings/security_privacy': '../modules/forms/views/settings/security_privacy.html',
                    'settings/skip_reasons': '../modules/forms/views/settings/skip_reasons.html',
                    'settings/sync_calendar': '../modules/forms/views/settings/sync_calendar.html',
                    'settings/time_geography': '../modules/forms/views/settings/time_geography.html',
                    'settings/talent_scout': '../modules/forms/views/settings/talent_scout.html',
                    'settings/user_management': '../modules/forms/views/settings/user_management.html',
                    'settings/employee_referral_management': '../modules/forms/views/settings/employee_referral_management.html',
                    'settings/employee_referral_messages_templates': '../modules/forms/views/settings/employee_referral_messages_templates.html',
                    'settings/document_uploader': '../modules/forms/views/settings/document_uploader.html',
                    'settings/custom_sources': '../modules/forms/views/settings/custom_sources.html',
                    'settings/invite_to_apply_templates': '../modules/forms/views/settings/invite_to_apply_templates.html',
                    'settings/approval_flow': '../modules/forms/views/settings/approval_flow.html',
                    'settings/carri_settings': '../modules/forms/views/settings/carri_settings_form.html',
                    'settings/documents_default_fields_settings': '../modules/forms/views/settings/documents_default_fields_settings.html',
                    'settings/minimum_minor_age_settings': '../modules/forms/views/settings/minimum_minor_age_settings.html',
                    'talent_pool/add_notes': '../modules/forms/views/talent_pool/add_notes.html',
                    'talent_pool/manage_tag': '../modules/forms/views/talent_pool/manage_tag.html',
                    'talent_pool/share_with_client': '../modules/forms/views/talent_pool/share_with_client.html',
                    'activated_successfully': '../modules/forms/views/activated_successfully.html',
                    'autocomplete': '../modules/forms/views/autocomplete.html',
                    'imageCropping': '../modules/forms/views/imageCropping.html',
                    'interview': '../modules/forms/views/interview.html',
                    'invite_to_apply': '../modules/forms/views/invite_to_apply.html',
                    'login': '../modules/forms/views/login.html',
                    'login_flow': '../modules/forms/views/login_flow.html',
                    'rapid_refrence': '../modules/forms/views/rapid_refrence.html',
                    'registration_flow': '../modules/forms/views/registration_flow.html',
                    'thank_you': '../modules/forms/views/thank_you.html',
                    'settings/career_site_builder': '../modules/forms/views/settings/career_story_settings.html',
                    'settings/apply_to_talent_pool_settings': '../modules/forms/views/settings/apply_to_talent_pool_settings.html',
                    'settings/automated_onboarding': '../modules/forms/views/settings/onboarding_automation_settings.html',
                };

                if (attrs.new) {
                    return '../modules/forms/views/default_template.html';
                }

                if (attrs.view) {
                    view = attrs.view;
                } else {
                    $log.error("view must be specified as attribute");
                    return false;
                }

                view = view.toLowerCase().replace(/\.(html)/g, "");
                view = FORMS_VIEWS_MAP[view] || console.error("hForm view html URL must be added in FORMS_VIEWS_MAP, can't find:", view);

                return view;
            },
            compile: function (element, attributes) {
                return {
                    post: function (scope, element, attrs, contr, transcludeFn) {


                        if (scope && contr) {
                            scope.$form = scope.$parent;
                        }

                        //index
                        if (!scope.flow) {
                            scope.flow = [];
                        }
                        var index = scope.flow.length;
                        var formName = null;
                        var viewName = attrs.view;

                        element.find("form, ng-form").eq(0).attr("h-form-index", index);

                        //push form information
                        scope.flow.push({element: element, attrs: attrs, index: index, formName: formName, viewName: viewName});

                        var dataName = scope.getDataName(index);

                        if (!scope.data) {
                            scope.data = {};
                        }

                        if (!scope.data[dataName]) {
                            scope.data[dataName] = {};
                        }

                        if (attrs.optional && (attrs.optional == "true" || attrs.optional == true)) {
                            scope.data[dataName]["optional"] = true;
                        }

                        if( attrs.optional ){
                             scope.$watch(function () {
                                return attrs.optional;
                            }, function(){
                                scope.data[dataName]["optional"] = attrs.optional;
                            });
                        }


                        if(attrs.options && $.trim(attrs.options)!="") {
                            if(!scope.options) {
                                scope.options = {};
                            }
                            scope.options[dataName] = scope.$eval(attrs.options);
                        }


                        //show the right form only
                        //if the form is part of wizard (settings page...) then listen to changeActiveForm Event
                        if (scope.isWizard) {

                          /* show form if this is the triggred and execute callbacks */
                          var triggerChangeForm = function(newForm, oldForm){

                              if (oldForm === index) {
                                  scope.beforeInActiveHandler(oldForm);
                              }

                            //Check the active form if it's equal to form index
                            if (newForm == index) {
                              //added Jan 1st, to wait until the callbacks to be loaded, should be tested system wide
                              hFormReference.getForm(viewName).then(function() {
                                //check if the form is still active after it's loaded
                                if (scope.activeForm == index) {
                                  scope.beforeActiveViewHandler(scope.activeForm).then(function () {
                                    scope.flow[scope.activeForm].element.show();
                                  })
                                      .catch(function (err) {
                                          hLog("formsDirectives", "beforeActiveViewHandler", err);
                                      });
                                }
                              })
                                  .catch(function (err) {
                                      hLog("formsDirectives", "hFormReference", err);
                                  });
                            } else {
                              element.hide();
                            }
                            /* kill watch after the first event triggred */
                            changeActiveFormOnce();
                          };


                          /* listne to change active form event */
                          scope.$on('forms:changeActiveForm', function (event, newForm, oldForm) {
                            triggerChangeForm(newForm, oldForm);
                          });

                          /* watch active form value for the first time, a fall back when the directive is not intialized yet
                          and brodcast will not work
                           */
                          var changeActiveFormOnce = scope.$watch("activeForm", function (newForm, oldForm) {
                              triggerChangeForm(newForm, oldForm);
                          });

                          element.hide();

                        }

                        hFormReference.setForm(viewName, element, scope);
                    }
                }
            }
        }
    }])

//    .directive('hScopeCall', [function() {
//        return {
//            restrict: "A",
//            scope:{
//                hScopeCall:'&'
//            },
//            link: function(scope, element, attr) {
//                element.bind("click", function() {
//                    scope.hScopeCall(scope)(scope.$parent);
//                });
//            }
//        }
//    }])

    .directive('remoteLoad', ['$log', '$filter', '$timeout', function ($log, $filter, $timeout) {
        return {
            restrict: "A",
            compile: function (element, attributes) {
                return {
                    post: function (scope, element, attrs, contr, transcludeFn) {

                        $timeout(function () {
                            var index = element.attr("h-form-index");
                            scope.remoteLoad({}, index);
                        });

                    }
                }
            }
        }
    }])

    .directive('hSaveForm', ['$log', '$filter', '$state', function ($log, $filter, $state) {
        return {
            restrict: "A",
            scope: {
                hSaveForm: '&',
                valid: '&',
                invalid: '&',
                validUiSref:'@'
            },
            link: function (scope, element, attr) {
                element.bind("click", submit);
                element.bind("submit", submit);

                element.attr("type", "submit");

                function submit(e) {

                    e.preventDefault();
                    var formName = element.closest("[view]").attr('view');
                    var formIndex = scope.$parent.indexOf(formName);

                    var loadingText = $(element).data('loading-text');
                    if( loadingText == "" ){
                      loadingText = $filter('translate')('Loading') + '...';
                    }

                    $(element).data('loading-text', loadingText);

                    if (scope.$parent.savingData) {
                        return;
                    }

                    scope.$parent.savingData = true;

                    var promise = scope.$parent.save(null, function (response) {

                        scope.$parent.savingData = false;

                        //response={valid: true, data: formData, saved: true, response:data, status:status}
                        try {
                            if (scope.hSaveForm) {
                                scope.hSaveForm(scope)(response, response.valid && response.saved);
                            }
                        } catch (e) {
                        }

                        try {
                            if (scope.validUiSref && response.valid && response.saved) {
                                scope.validUiSref = parseStateRefToUiSrefObj(scope.validUiSref);
                                $state.go(scope.validUiSref.state, scope.$eval(scope.validUiSref.paramExpr));
                            }
                        } catch (e) {
                        }


                        try {
                            if (scope.valid && response.valid && response.saved) {
                                scope.valid(scope)(response, response.valid && response.saved);
                            }
                        } catch (e) {
                        }

                        try {
                            if (scope.invalid && (!response.valid || !response.saved)) {
                                scope.invalid(scope)(response, response.valid && response.saved);
                            }
                        } catch (e) {
                        }

//                        if(response.valid && response.saved) {
//                            if(scope.hSaveForm) {
//                                scope.hSaveForm(response);
//                            }
////                            scope.$parent.next();
//                        }

                        element.button('reset');
                    }, undefined, formIndex, scope.$parent[attr.recaptcha], function () {
                        $(element).button().button('loading');
                    });

                    if (promise) {
                        promise.catch(function (err) {
                            console.error(err);
                        });
                    }
                }

            }
        }
    }])


    .directive('hFormReset', [function () {
        return {
            restrict: "A",
            link: function (scope, element, attr) {
                element.bind("click", function () {
                    scope.$parent.reset();
                });
            }
        }
    }])


    .controller("hFormController", ["$scope", "$http", "$resource", "$timeout", "$log", "$filter", "$parse", "asyncGlobalHandler", "$q", "httpHelper", "$state", "$rootScope", "localize", "hFormReference",
        function ($scope, $http, $resource, $timeout, $log, $filter, $parse, asyncGlobalHandler, $q, httpHelper, $state, $rootScope, localize, hFormReference) {
        $scope.layout = '';
        $scope.id = '';
        $scope.savingData = false;

        //scope.flow.push({element: element, attrs:attrs, index: index, formName: null, viewName: viewName});
        $scope.flow = [];

        //forms must be inside
        $scope.forms = {};

        //form's data must be inside
        $scope.data = {};

        //set the first page in the flow
        $scope.activeForm = 0;
        //fire the change active form event
        $rootScope.$broadcast('forms:changeActiveForm', 0);

        $scope.triggerActiveFormChange = true;

        $scope.setActiveForm = function (index) {
            $scope.activeForm = index;
        };

        $scope.getApi = function (index) {
            if (index === undefined) {
                index = $scope.activeForm;
            }

            var element = $scope.flow[index].element;
            var parentElem = $(element).parent().find("[h-form-index='" + index + "']");

            var api = parentElem.attr("h-form-action");
            var apiVersion = parentElem.attr("version");

            if (!api) {
                $log.error("Form with empty API can't be submitted, formIndex:", $scope.getDataName(index));
                return;
            }

            if (api.indexOf("://") == -1) {
                api = publicConfiguration.APIServerBaseURL + api;
            }

            if (apiVersion) {
                api = api.replace('v1', 'v' + apiVersion);
            }

            return api;
        };

        $scope.setSaveMethod = function (method, index) {
            return $scope.getFormDOM(index).attr("method", method);
        };

        $scope.getSaveMethod = function (index) {
            return $scope.getFormDOM(index).attr("method");
        };

        $scope.setFormAction = function (method, index) {
            return $scope.getFormDOM(index).attr("h-form-action", method);
        };

        $scope.getDataName = function (index) {

            if (!index) {
                index = $scope.activeForm;
            }
            return $scope.getFormDOM(index).attr("form-data");
        };

        $scope.removeListeners = function() {
            $scope.beforeSaveCallbacks = [];
            $scope.afterSaveCallbacks = [];
            $scope.afterLoadCallbacks = [];
            $scope.beforeActiveViewCallbacks = [];
            $scope.afterActiveFormChangeCallbacks = [];
            $scope.beforeInActiveCallbacks = [];
        };

        $scope.reset = function (ignoreFields, index) {
            var formData = $scope.getData(index);
            var formCont = $scope.getForm(index);

            try {
                formCont.$setPristine();
                formCont.$setUntouched();
            } catch (e) {
            }

            for (var k in formData) {

                if (ignoreFields && ignoreFields[k] === true) {
                    continue;
                }

                delete formData[k];
            }

            $scope.$broadcast('show-errors-reset');
            return true;
        };

        $scope.getData = function (index) {
            var dataKey = $scope.getDataName(index);
            if (!$scope.data[dataKey]) {
                $scope.data[dataKey] = {};
            }
            return $scope.data[dataKey];
        };

        $scope.getForm = function (index) {
            var dataKey = $scope.getDataName(index);
            if (!$scope.forms[dataKey]) {
                $scope.forms[dataKey] = {};
            }
            return $scope.forms[dataKey];
        };

        $scope.getFormDOM = function (index) {
            if (index === undefined) {
                index = $scope.activeForm;
            }
            if (!$scope.flow[index].formDOM) {
                var element = $scope.flow[index].element;
                var formDOM = element.find("form, ng-form").eq(0);

                $scope.flow[index].formDOM = formDOM;
            }

            if (!$scope.flow[index].formDOM) {
                $log.error("Form DOM object not found!");
            }

            return $scope.flow[index].formDOM;
        };

        $scope.getFormName = function (index) {
            if (!index) {
                index = $scope.activeForm;
            }

            if (!$scope.flow[index].formName) {
                var form = $scope.getFormDOM(index);
                var formName = form.attr("name");
                $scope.flow[index].formName = formName;
            }

            return $scope.flow[index].formName;
        };

        $scope.getForm = function (index) {
            return $scope.$eval($scope.getFormName(index));
        };

        $scope.savePromise = function (viewName) {
            var index = $scope.indexOf(viewName);
            var defer = $q.defer();

            $scope.save(null, function (response) {

                if (response.valid && response.saved) {
                    defer.resolve(response);
                } else {
                    defer.reject(response);
                }

            }, undefined, index);

            return defer.promise;
        };

        $scope.save = function ($event, $callback, dontValidate, index, recaptchaFunc, onRecaptchaSuccessCallBack) {
            var deferred = $q.defer();
            //remove validation
            var validate = !(dontValidate == true);
            var valid = true;

            var formData = $scope.getData(index);
            if ($event) {
                $event.preventDefault();
            }


            if (!index) {
                index = $scope.activeForm;
            }

            function remoteSave(gRecaptchaResponse) {
                //a.k.a remote saving

                if (gRecaptchaResponse) {
                    formData['g-recaptcha-response'] = gRecaptchaResponse;
                }

                $scope.remoteValidation(function (status, data, formData, requestStatus, headers, config) {
                    var r = {valid: status, data: formData, saved: status, response: data};

                    if (status) {
                        deferred.resolve(r);
                    } else {
                        deferred.reject(r);
                    }


                    if ($callback) {
                        $callback(r);
                    }

                }, index, formData);
            }

            function reject(canceled) {
                var r = {valid: false, data: formData, saved: false, canceled: canceled};
                deferred.reject(r);

                if ($callback) {
                    $callback(r);
                }
            }

            function remoteSaveOrReject() {

                if (valid) {
                    if (recaptchaFunc) {
                        recaptchaFunc().then(function (gRecaptchaResponse) {
                            if (onRecaptchaSuccessCallBack) {
                                onRecaptchaSuccessCallBack();
                            }
                            remoteSave(gRecaptchaResponse);
                        })
                            .catch(function (err) {
                                hLog("formsDirectives", "recaptchaFunc", err);
                            });
                    } else {
                        remoteSave();
                    }
                } else {
                    reject(false);
                }
            }

            if (validate) {
                //validate locally

                if ($scope.localInvalidity(index)) {
                    //valida locally
                    //validate remotly
                    valid = true;
                } else {
                    //not valida locally
                    //reject
                    valid = false;
                }
            }



            var promises = [];
            //before save callbacks
            if ($scope.beforeSaveCallbacks[index] && $scope.beforeSaveCallbacks[index].length > 0) {
                var copyFromData = angular.copy(formData);
                for (var k in $scope.beforeSaveCallbacks[index]) {
                    var c = $scope.beforeSaveCallbacks[index][k];
                    var promise = c(angular.copy(formData), valid);

                    promises.push($q.when(promise));
                }
            }

            $q.all(promises)
                .then(function (beforeSaveResponses) {

                    for (var k in beforeSaveResponses) {
                        var retunredData = beforeSaveResponses[k];

                        if (retunredData || retunredData == undefined) {
                            if (retunredData)
                                formData = retunredData;
                        } else {//cancel the request && save process
                            reject(true);
                            return deferred.promise;
                        }
                    }
                    remoteSaveOrReject();
                })
                .catch(function (err) {
                    console.error(err);
                });


            return deferred.promise;
        };



        $scope.invalidate = function(data, index, dontBroadCast) {

            var form = $scope.getForm(index);

            if(!angular.isArray(data.data)) {
                data.data = [data.data];
            }

            form.response = data.data;
            form.status_code = data.status_code;

            for (var k in data.data) {
                var error = data.data[k];

                if (!form[error.field]) {
                    //returned field not found
                    continue;
                }

                if (form[error.field]) {
                    form[error.field].$setValidity("h-server-error", false);
                    form[error.field].message = $filter("translate")(error.error);
                }
            }

            if( !dontBroadCast ){
                $scope.$broadcast('show-errors-check-validity');
            }
        };

        $scope.resetRemoteValidation = function(index) {
            var formData = $scope.getData(index);
            var formCont = $scope.getForm(index);

            try {
                formCont.$setPristine();
                formCont.$setUntouched();
            } catch (e) {
            }
            for (var k in formCont) {
              if(angular.isObject(formCont[k]) && formCont[k].$error && formCont[k].$error["h-server-error"]) {
                  formCont[k].$setValidity("h-server-error", true);
              }
            }

            $scope.$broadcast('show-errors-reset');
            return true;
        };

        $scope.remoteValidation = function (cb, index, formData) {

            var defer = $q.defer();

            if (!index) {
                index = $scope.activeForm;
            }

            if (!formData) {
                formData = $scope.getData(index);
            }

            var form = $scope.getForm(index);

            var method = $scope.getSaveMethod(index);
            if (!method) method = 'POST';

            var status = false;

//            form.$_processing = true;

            function handleResonse(data, requestStatus, headers, config) {

                if (data && (data.status_code == 600 || data.status_code == 403)) {

                    $scope.invalidate(data, index);

                } else if (data.status_code == 200 || (typeof(data) === 'string' && data.toLowerCase().indexOf("success") > -1)) {
                    status = true;

                } else {
                    if (data.status) {
                        form.errorMessage = $filter("translate")(data.status);
                    }
                    else if (data && data[0] && data[0].error) {
                        form.errorMessage = $filter("translate")(data[0].error);
                    }

                    if (data.status_code != 304) {
                        $log.error("Unknown server error", data.status_code);
                    }

                    $scope.$broadcast('show-errors-check-validity');
                }

                if (cb) {
                    cb(status, data, formData, requestStatus, headers, config);
                }

                if (status) {
                    defer.resolve(status, data, formData, requestStatus, headers, config);
                } else {
                    defer.reject(status, data, formData, requestStatus, headers, config);
                }
            }

            function handleError(data, status, headers, config) {
                status = false;
                form.$_processing = false;

                if (data.code === 'NotAuthorizedException' && data.message === 'Incorrect username or password.') {
                    form.errorMessage = $filter("translate")('Wrong old password');
                } else if(data && data.message) {
                    form.errorMessage = $filter("translate")(data.message);
                } else {
                    form.errorMessage = $filter("translate")(data);
                }

//                $log.error("Unknown server error", data);

                $scope.$broadcast('show-errors-check-validity');

                if (cb) {
                    cb(status, data, formData, null, headers, config);
                }

                defer.reject(status, data, formData, null, headers, config);
            }

            function handleErrorsInResponse(data, status, headers, config){
                    handleError(data, status, headers, config);
                    hLog("FORMS", "RESPONSE_ERROR", {data:data, status:status, headers:headers, config:config});
            }

            var promise = httpHelper.$http({ url: $scope.getApi(index), method: method, data: formData, withCredentials: true }).then(function (res, requestStatus, headers, config) {
                status = false;
                var data = res.data? res.data: res;

                // A workaround to solve:
                // https://harridev.atlassian.net/browse/HARRI-19648
                if (res.brand_id) {
                    data = res;
                }

//                form.$_processing = false;


                var promises = [];
                // in case response has errors
                if( data[0] && data[0].data && data[0].data.data && data[0].data.data[0] && data[0].data.data[0].error){
                    handleErrorsInResponse(data[0].data.data[0].error, status, headers, config);
                }
                else{
                    //after save callbacks
                    if ($scope.afterSaveCallbacks[index] && $scope.afterSaveCallbacks[index].length > 0) {
                        for (var k in $scope.afterSaveCallbacks[index]) {
                            var c = $scope.afterSaveCallbacks[index][k];
                            var promise = c(data, formData, requestStatus);

                            promises.push($q.when(promise));
//                        if(returnedData) {
//                            data = returnedData;
//                        }
                        }
                    }

                    $q.all(promises)
                        .then(function (afterSaveResponse) {
                            for (var k in afterSaveResponse) {
                                var retunredData = afterSaveResponse[k];

                                if (retunredData) {
                                    data = retunredData;
                                } else {//cancel the request && save process
                                    handleResonse(data, requestStatus, headers, config);
                                    return defer.promise;
                                }
                            }

                            handleResonse(data, requestStatus, headers, config)
                        })
                        .catch(function (err) {
                            hLog("formsDirectives", "afterSaveResponse", err);
                        });
                }

            }, function (data, status, headers, config) {
                handleErrorsInResponse(data, status, headers, config);
            });


            asyncGlobalHandler.watchPromise(defer.promise);
            return defer.promise;
        };

        $scope.validate = function (index) {
            $scope.$broadcast('show-errors-check-validity');

            var $form = $scope.getForm(index);
            return $form && $form.$valid;
        };


        $scope.localInvalidity = function (index) {
            $scope.$broadcast('show-errors-check-validity');

            var $form = $scope.getForm(index);

            var localInvalidity = false;
            if ($form) {
                for (var k in $form.$error) {
                    if (k !== "recaptcha" && $form.$error[k] !== false && $form.$error[k].length > 0 && k != "h-server-error") {
                        localInvalidity = true;
                        break;
                    }
                }
            }
            else {
                console.warn("Can't find form: with index:", index);
            }

            return !localInvalidity;
        };


        //animate
        //add attribute to any element h-form-animate="key" and call it $scope.animate("key", "pulse");
        //http://daneden.github.io/animate.css/
        //https://github.com/daneden/animate.css/blob/master/animate-config.json
        $scope.animate = function (key, animation) {
            $scope.$broadcast("animate-key", animation);
        };

        $scope.next = function (dontValidate) {
            $scope.gotoIndex($scope.activeForm + 1);
        };

        $scope.prev = function (dontValidate) {
            $scope.gotoIndex($scope.activeForm - 1);
        };

        $scope.saveForm = function () {
            $scope.saving = true;

            $scope.newActiveForm.validator.validate(function (isValid) {
                if (isValid) {
                    $scope.newActiveForm
                        .save()
                        .catch(function (err) {
                            console.error(err);
                        })
                        .finally(function () {
                            $scope.saving = false;
                            var formIndex = $scope.views.findIndex(function (view) {
                                return $scope.activeView === view.form;
                            });
                            var nextFormIndex = formIndex + 1;
                            if (nextFormIndex === $scope.views.length || $scope.views[nextFormIndex].view === 'hosted_video') {
                                nextFormIndex = 0;
                            }

                            $state.go('.', {view: $scope.views[nextFormIndex].view});
                        });
                } else {
                    $scope.saving = false;
                }
            });
        };

        $scope.getFromName = function (index) {
            if (!index) {
                index = $scope.activeForm;
            }
            if ($scope.flow[index]) {
                return $scope.flow[index].viewName;
            } else {
                return undefined;
            }
        };

        $scope.indexOf = function (formName) {

            var index = null;
            for (var i in $scope.flow) {
                var viewName = $scope.flow[i].viewName;
                if (viewName == formName) {
                    index = i;
                    break;
                }
            }

            return index;
        };

        $scope.goto = function (form_name) {
            var index = $scope.indexOf(form_name);

            $scope.gotoIndex(index);
//            if(!$scope.$$phase && !$scope.$root.$$phase) {
//                $scope.$apply();
//            }
        };

        $scope.closeModal = function () {
            $($scope.getFormDOM()).closest(".modal").modal("close");
        };

        $scope.gotoIndex = function (index) {
            index = parseInt(index);
            $scope.$broadcast('show-errors-reset');
            $scope.triggerActiveFormChange = false;


            // reset forms backend message
            $timeout(function(){
                if( $scope.forms ){
                    for( var form_name in $scope.forms ){
                        $scope.forms[form_name].errorMessage = '';
                    }
                    $scope.$apply();
                }
            });

            if (index >= $scope.flow.length || index < 0) {
                return false;
            }

            $scope.previousActive = $scope.activeForm;
            $scope.activeForm = index;

            if ($scope.flow[index].attrs.new) {
                $scope.activeView = $scope.flow[index] && $scope.flow[index].viewName;
                $scope.activeFormTitle = $scope.flow[index].attrs.title;
                $scope.newActiveForm = hFormReference.formsObjMap[$scope.flow[$scope.activeForm].viewName].form;
                $scope.newActiveForm.load();
            }

            /* fire change active form for wizards (settings) */
            if($scope.isWizard){
              $rootScope.$broadcast('forms:changeActiveForm', $scope.activeForm, $scope.previousActive);
            }

            $timeout(function () {
                $scope.$apply();

                //run flow callback | afterActiveFrom
                if ($scope.afterActiveFormChangeCallbacks) {
                    for (var k in $scope.afterActiveFormChangeCallbacks) {
                        $scope.afterActiveFormChangeCallbacks[k]();
                    }
                }

                $scope.triggerActiveFormChange = true;
            });

            return true;
        };


        /**
         * Example of how to add a before save callback
         scope.addBeforeSaveCallback({
            'login':
                function (formData) {
                    //it's important to return
                    return formData;
                }
        });

         //
         scope.addAfterSaveCallback({
            'login':
                function(response) {
                    return response;
                }
        });
         */
        $scope.beforeSaveCallbacks = [];
        $scope.addBeforeSaveCallback = function (callbackObj) {
            for (var viewName in callbackObj) {
                var index = $scope.indexOf(viewName);

                if (!$scope.beforeSaveCallbacks[index]) {
                    $scope.beforeSaveCallbacks[index] = [];
                }

                if ($scope.beforeSaveCallbacks[index]) {
                    $scope.beforeSaveCallbacks[index].push(callbackObj[viewName]);
                }

            }
        };

        $scope.afterSaveCallbacks = [];
        $scope.addAfterSaveCallback = function (callbackObj) {
            for (var viewName in callbackObj) {
                var index = $scope.indexOf(viewName);

                if (!$scope.afterSaveCallbacks[index]) {
                    $scope.afterSaveCallbacks[index] = [];
                }

                if ($scope.afterSaveCallbacks[index]) {
                    $scope.afterSaveCallbacks[index].push(callbackObj[viewName]);
                }

            }
        };

        $scope.afterLoadCallbacks = [];
        $scope.addAfterLoadCallback = function (callbackObj) {
            for (var viewName in callbackObj) {
                var index = $scope.indexOf(viewName);

                if (!$scope.afterLoadCallbacks[index]) {
                    $scope.afterLoadCallbacks[index] = [];
                }

                if ($scope.afterLoadCallbacks[index]) {
                    $scope.afterLoadCallbacks[index].push(callbackObj[viewName]);
                }

            }
        };


        $scope.beforeInActiveCallbacks = [];
        $scope.addBeforeInActiveCallback = function (callbackObj) {
            for (var viewName in callbackObj) {
                var index = $scope.indexOf(viewName);

                if (!$scope.beforeInActiveCallbacks[index]) {
                    $scope.beforeInActiveCallbacks[index] = [];
                }

                if ($scope.beforeInActiveCallbacks[index]) {
                    $scope.beforeInActiveCallbacks[index].push(callbackObj[viewName]);
                }

            }
        };

        $scope.beforeActiveViewCallbacks = [];
        $scope.beforeActiveViewCallback = function (callbackObj) {
            for (var viewName in callbackObj) {
                var index = $scope.indexOf(viewName);
                if (!$scope.beforeActiveViewCallbacks[index]) {
                    $scope.beforeActiveViewCallbacks[index] = [];
                }

                if ($scope.beforeActiveViewCallbacks[index]) {
                    $scope.beforeActiveViewCallbacks[index].push(callbackObj[viewName]);
                }
            }
        };

        //alias for beforeActiveViewCallback
        $scope.addBeforeActiveViewCallback = function (callbackObj) {
            return $scope.beforeActiveViewCallback(callbackObj);
        };

        //flow level callbacks
        $scope.afterActiveFormChangeCallbacks = [];
        $scope.afterActiveFormChange = function (callback) {
            $scope.afterActiveFormChangeCallbacks.push(callback);
        };

        $scope.flowBeforeActiveViewLoader = function () {
            var loadersPromises = [];
            for (var k in $scope.flow) {
                var p = $scope.beforeActiveViewHandler($scope.flow[k].index);
                loadersPromises.push(p);
            }
            return $q.all(loadersPromises);
        };

        $scope.beforeActiveViewHandler = function (index) {
            var defer = $q.defer();
            var callbackPromises = [];
            //after load callbacks
            if ($scope.beforeActiveViewCallbacks[index] && $scope.beforeActiveViewCallbacks[index].length > 0) {

                for (var k in $scope.beforeActiveViewCallbacks[index]) {

                    var c = $scope.beforeActiveViewCallbacks[index][k];
                    var response = c($scope);
                    //kill the goto if the returned data was false
                    if (response === false) {
                        defer.reject(response);
                        break;
                    }

                    callbackPromises.push($q.when(response));
                }
            }

            $q.all(callbackPromises).then(function (r) {
                defer.resolve(r);
            })
                .catch(function (err) {
                    hLog("formsDirectives", "callbackPromises", err);
                });

            return defer.promise;
        };

        $scope.beforeInActiveHandler = function (index) {
            var defer = $q.defer();
            var callbackPromises = [];
            //after load callbacks
            if ($scope.beforeInActiveCallbacks[index] && $scope.beforeInActiveCallbacks[index].length > 0) {

                for (var k in $scope.beforeInActiveCallbacks[index]) {

                    var c = $scope.beforeInActiveCallbacks[index][k];
                    var response = c($scope);
                    //kill the goto if the returned data was false
                    if (response === false) {
                        defer.reject(response);
                        break;
                    }

                    callbackPromises.push($q.when(response));
                }
            }

            $q.all(callbackPromises).then(function (r) {
                defer.resolve(r);
            })
                .catch(function (err) {
                    hLog("formsDirectives", "callbackPromises", err);
                });

            return defer.promise;
        };

        /**
         * Load data object to form components
         * @param data JSON abstract data example {firstname: 'Ayman'}
         * @param index Optional Int form index
         * @returns $scope.load
         */
        $scope.loadData = function (data, index, clearOriginalObj) {
            var dataKey = $scope.getDataName(index);
            var dataObj = {};
            dataObj[dataKey] = data;

            return $scope.load(dataObj, clearOriginalObj);
        };

        /**
         * Load data into forms components
         * @param data JSON load forms data, example {'form_prefix': {firstname: 'Ayman'}}
         */
        $scope.load = function (data, clearOriginalObj) {
            for (var k in data) {
                if (!$scope.data[k] || clearOriginalObj) {
                    $scope.data[k] = {};
                }
                for (var kk in data[k]) {
                    $scope.data[k][kk] = data[k][kk];
                }
            }
        };

        $scope.remoteLoad = function (params, index, keepAttrsArray) {
            var form = $scope.getForm(index);

            var url = $scope.getApi(index);
            if (params && params.id) {
                url = url + "/" + params.id;
            }

//            form.$_processing = true;
            var promise = $http({ url: url, method: 'GET', data: params, withCredentials: true });

            promise.then(function (res, requestStatus, headers, config) {

                var data = res.data? res.data: res;

                //after load callbacks
                if ($scope.afterLoadCallbacks[index] && $scope.afterLoadCallbacks[index].length > 0) {
                    for (var k in $scope.afterLoadCallbacks[index]) {
                        var c = $scope.afterLoadCallbacks[index][k];
                        var returnedData = c(data);
                        if (returnedData) {
                            data = returnedData;
                        }
                    }
                }

//                form.$_processing = false;

                if (data.status_code == 600) {

                    $log.error("Unknown server error", data, requestStatus, headers, config);

                } else if (data.status_code == 200) {



                    //success
                    if (data.data) {
                        data = data.data;
                    }

                    var isEmpty = isDataEmpty(data);

                    if(!isEmpty) {
                        var dataName = $scope.getDataName();
                        var loadedData = {};

                        if(keepAttrsArray) {
                            data = keepAttrs(data, keepAttrsArray);
                        }

                        loadedData[dataName] = data;
                        $scope.load(loadedData);

                        if ($scope.getSaveMethod(index) !== 'PUT') {
                            $scope.setSaveMethod("POST", index);
                        }
                    }

                } else {

                    form.errorMessage = $filter("translate")(data.status);

                    if (data.status_code != 304) {
                        $log.error("Unknown server error", data.status_code, data, requestStatus, headers, config);
                    }

                }

            }, function (data, status, headers, config) {
//                form.$_processing = false;

                form.errorMessage = $filter("translate")(data);
                $log.error("Unknown server error", data);

            });

            asyncGlobalHandler.watchPromise(promise);

            return promise;

        };

        //For Password Validation 
        $scope.passwordStrength = {};

    }])

    .factory("hFormReference", ['$q', '$timeout', function ($q, $timeout) {
        var hFormReference = {
            forms: {},
            defers: {},
            formsObjMap: {},

            setForm: function (name, element, scope) {
                hFormReference.forms[name] = {element: element, scope: scope};
                if (hFormReference.defers[name] && hFormReference.defers[name].length > 0) {
                    var defers = hFormReference.defers[name];
                    for (var k in defers) {
                        defers[k].resolve(hFormReference.forms[name]);
                        delete defers[k];
                    }
                }
            },
            callbacks: function (view, callbacks, load) {
                var promise = hFormReference.getForm(view);

                promise.then(function (formObj) {
                    var $scope = formObj.scope;

                    if (callbacks && callbacks.beforeActive) {
                        var obj1 = {};
                        obj1[view] = callbacks.beforeActive;
                        $scope.addBeforeActiveViewCallback(obj1);
                    }

                    if (callbacks && callbacks.beforeSave) {
                        var obj2 = {};
                        obj2[view] = callbacks.beforeSave;
                        $scope.addBeforeSaveCallback(obj2);
                    }

                    if (callbacks && callbacks.afterSave) {
                        var obj3 = {};
                        obj3[view] = callbacks.afterSave;
                        $scope.addAfterSaveCallback(obj3);
                    }

                    if (callbacks && callbacks.afterLoad) {
                        var obj4 = {};
                        obj4[view] = callbacks.afterLoad;
                        $scope.addAfterLoadCallback(obj4);
                    }

                    if (callbacks && callbacks.beforeDeactivate) {
                        var callbackObj = {};
                        callbackObj[view] = callbacks.beforeDeactivate;
                        $scope.addBeforeInActiveCallback(callbackObj);
                    }

                    if (callbacks && callbacks.loadOnActive) {

                        var index = $scope.indexOf(view);
                        var obj6 = {};
                        obj6[view] = function (scope) {
                            $q.when(callbacks.loadOnActive(scope)).then(function (data) {
                                var dataName = $scope.getDataName(index);
                                var loadedData = {};
                                loadedData[dataName] = data;
                                $scope.load(loadedData);
                            })
                            .catch(function (err) {
                                hLog("formsDirectives", "loadOnActive", err);
                            });
                        };
                        $scope.addBeforeActiveViewCallback(obj6);

                    }


                    if (load === true) {

                        var obj5 = {};
                        obj5[view] = function () {
                            var index = $scope.indexOf(view);
                            $scope.remoteLoad({}, index);
                        };
                        $scope.addBeforeActiveViewCallback(obj5);

                    }

                })
                .catch(function (err) {
                    hLog("formsDirectives", "hFormReference", err);
                });

                return promise;
            },

            current: function (element, callbacks, load) {
                if (!element) return false;
                var view = element.attr("view");
                return hFormReference.callbacks(view, callbacks, load);
            },

            getForm: function (name) {

                var defer = $q.defer();

                if (this.forms[name]) {
                    $timeout(function () {
                        defer.resolve(hFormReference.forms[name]);
                    })
                } else {
                    if (!hFormReference.defers[name]) {
                        hFormReference.defers[name] = [];
                    }

                    hFormReference.defers[name].push(defer);
                }
                return defer.promise;
            },

            deleteForm: function (name) {
                this.forms[name] = null;
                hFormReference.defers[name] = null;
            }
        };
        return hFormReference;
    }])

/**
 * This directive check if the input in children elements it's valid or not and add or remove has-error class.
 * This directive was created to show to add has-error bootstrap class on the element.
 *
 * add-has-error-class="myExternalVariable" -> is an external variable within the same scope the determine if the current form is valid or not
 *
  <div class="form-group col-lg-4 col-md-3 col-sm-4 col-xs-12" add-has-error-class="myExternalVariable">
                <label class="control-label" for="myinput">{{'My input' | translate}}</label>

                <input type="text" class="form-control" ng-model="data.test" name="myinput" id="myinput">

                <div class="text-danger"
                     ng-show="myform.myinput.$error.requried &&  ( forms.open_call.message.$touched || showCBErrors )">
                    {{ 'This field is required' | translate }}
                </div>
    </div>
 */
    .directive('addHasErrorClass', function () {

        return {
            require: '^form',
            link: function (scope, el, attrs, formCtrl) {
                var input = el.find('[name]');
                if (input) {
                    var inputName = input.attr('name');
                    if (inputName) {
                        scope.$watch(function () {
                            return  formCtrl[ inputName ].$invalid &&
                                ( formCtrl[ inputName ].$touched || scope.$eval(attrs.addHasErrorClass) );
                        }, function (val) {
                            if (val) {
                                el.addClass('has-error');
                            }
                            else {
                                el.removeClass('has-error');
                            }
                        });
                    }
                }
            }
        }
    })

//    show-errors
//    https://github.com/paulyoder/angular-bootstrap-show-errors
    .directive('showErrors', [
        '$timeout',
        'showErrorsConfig',
        function ($timeout, showErrorsConfig) {
            var getShowSuccess, linkFn;
            getShowSuccess = function (options) {
                var showSuccess;
                showSuccess = showErrorsConfig.showSuccess;
                if (options && options.showSuccess != null) {
                    showSuccess = options.showSuccess;
                }
                return showSuccess;
            };
            linkFn = function (scope, el, attrs, formCtrl) {
                var blurred, inputEl, inputName, inputNgEl, options, showSuccess, toggleClasses;
                blurred = false;
                options = scope.$eval(attrs.showErrors);
                showSuccess = getShowSuccess(options);
                inputEl = el[0].querySelector('[name]');
                inputNgEl = angular.element(inputEl);
                inputName = inputNgEl.attr('name');

                if (!inputName) {
                    throw 'show-errors element has no child input elements with a \'name\' attribute';
                }
                inputNgEl.bind('blur', function () {
                    blurred = true;
                    return toggleClasses(formCtrl[inputName].$invalid);
                });

                scope.$watch(function () {
                    inputName = inputNgEl.attr('name');
                    return formCtrl[inputName] && formCtrl[inputName].$invalid;
                }, function (invalid) {
                    if (!blurred) {
                        return;
                    }
                    return toggleClasses(invalid);
                });

                scope.$on('show-errors-check-validity', function () {
                    inputName = inputNgEl.attr('name');

                    if (options && options['pristine']) {
                        return !formCtrl.$pristine && toggleClasses(formCtrl[inputName].$invalid);
                    }
                    else {
                        return formCtrl[inputName] && toggleClasses(formCtrl[inputName].$invalid);
                    }
                });

                scope.$on('show-errors-check-validity-pristine', function () {
                    inputName = inputNgEl.attr('name');
                    return  toggleClasses(formCtrl[inputName].$invalid);
                });

//                scope.$on('show-errors-check-validity', function () {
//                    return toggleClasses(formCtrl[inputName].$invalid);
//                });
                scope.$on('show-errors-reset', function () {
                    return $timeout(function () {
                        el.removeClass('has-error');
                        el.removeClass('has-success');
                        return blurred = false;
                    }, 0, false);
                });
                return toggleClasses = function (invalid) {
                    el.toggleClass('has-error', invalid);
                    if (showSuccess) {
                        return el.toggleClass('has-success', !invalid);
                    }
                };
            };
            return {
                restrict: 'A',
                require: '^form',
                compile: function (elem, attrs) {

                    if (!elem.hasClass('form-group')) {
                        throw 'show-errors element does not have the \'form-group\' class';
                    }

                    return {
                        post: linkFn
                    }
                }
            };
        }
    ])
    .provider('showErrorsConfig', function () {
        var _showSuccess;
        _showSuccess = false;
        this.showSuccess = function (showSuccess) {
            return _showSuccess = showSuccess;
        };
        this.$get = function () {
            return { showSuccess: _showSuccess };
        };
    })

    .directive('lookup', ['httpHelper', '$parse', function (httpHelper, $parse) {
        return {
            link: function (scope, element, attr) {
                var mappingFunction;

                if (attr.lookupName && attr.lookupName != 'name') {
                    mappingFunction = function (obj) {
                        return {label: obj[attr.lookupName], value: obj.id };
                    }
                }

                httpHelper.getList(attr.lookup, mappingFunction).then(function (r) {
                    assign(r);
                }, function () {
                    assign([]);
                });

                function assign(r) {
                    var $model = $parse(attr.lookupData);
                    $model.assign(scope, r);
                }
            }
        }
    }]);
